import { IClientMessage } from '../interfaces/IClientMessage';

/** Box prefix of the form state of a message, safe for lodash paths. */
export const getMessageFormPrefix = (client_id: IClientMessage['client_id']) =>
	`messages.entities["${client_id}"]._meta.form`;
